import * as React from 'react';
import State from 'src/react/components/meta/types/State';
import { connect } from 'react-redux';
import { META_REDUCER_NAME } from 'src/react/components/meta/constants';
import { reducerRegistry } from '@collaborator/npm_modules/dist/components/redux';
import reducer from 'src/react/components/meta/reducers';
import { TITLE } from 'moduleBase/constants';
import { FC } from 'react';

reducerRegistry.register(META_REDUCER_NAME, reducer);

type MetaH1Props = {
  title: string,
  h1: string,
};

const MetaH1: FC<MetaH1Props> = ({ title, h1 }) => (
  <h1>
    {h1 || title || TITLE}
  </h1>
);

const mapStateToProps = (state: {
  [META_REDUCER_NAME]: State,
}) => ({
  title: state[META_REDUCER_NAME].title,
  h1: state[META_REDUCER_NAME].h1,
});

export default connect(mapStateToProps)(MetaH1);
